import { gql } from "config/graphql";
import {
  BillingFrequency,
  MutationResponse,
  QuotesStatus,
  SuccessResponse,
  TermUnit,
} from "config/types";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

export interface IUpdateQuoteInput {
  quoteId: string;
  termUnit?: TermUnit;
  termDuration?: number;
  amount?: number;
  status?: QuotesStatus;
  billingFrequency?: BillingFrequency;
}

interface IUpdateQuoteData {
  updateQuote: SuccessResponse;
}

export const updateQuoteMutation: MutationResponse<IUpdateQuoteInput, IUpdateQuoteData> = async (
  quote: IUpdateQuoteInput
) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation updateQuote($input: UpdateQuoteInput!) {
      updateQuote(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IUpdateQuoteData>({
    variables: { input: quote },
    mutation,
  });
  return { data: assertDefined(data) };
};
